import * as React from "react";
import { clsx } from "clsx";
import { Icon } from "../icon/icon/icon.mjs";
const Badge = (props) => {
  const { className, icon, purpose, responsiveSize, size, text, width, ...rest } = props;
  const textLength = React.useMemo(() => {
    let textLength2;
    if (typeof text === "string") {
      textLength2 = text.length;
    } else {
      textLength2 = ("" + text).length;
    }
    return textLength2;
  }, [text]);
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: clsx(
        "badge",
        {
          ["badge--".concat(purpose)]: !!purpose,
          ["badge--".concat(size)]: !!size,
          ["badge--".concat(size, "-responsive")]: size === "large" && responsiveSize,
          "badge--two-digits": width === "fixed" && textLength === 2,
          "badge--three-digits": width === "fixed" && textLength === 3
        },
        className
      ),
      ...rest
    },
    icon && /* @__PURE__ */ React.createElement(Icon, { className: "badge__icon", modifiers: icon }),
    text && /* @__PURE__ */ React.createElement("span", { className: "badge__text" }, text)
  );
};
export {
  Badge
};
